import Logo from "images/logos/tonatrenujes.svg";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, Image } from "react-bootstrap";

import { useGetCurrentUserQuery } from "api/generated";

interface Props {
  hasStoredToken: boolean;
  isRetrying: boolean;
  onRetry: () => void;
  onContinue: () => void;
}

// AIDEV-NOTE: Přihlášení selhalo kvůli výpadku Zóny, ne kvůli studentovi. Kdo má v prohlížeči
// platný token z dřívějška, může pokračovat; kvůli sdíleným počítačům se ptáme celým jménem
// („Pokračovat jako Jana Nováková?“), křestní jméno by dvě Jany ve třídě nerozlišilo. Jméno
// se čte se starým tokenem, `currentUser` Zónu nevolá. [TD-496]
const ZonaUnavailable = ({ hasStoredToken, isRetrying, onRetry, onContinue }: Props) => {
  const { t } = useTranslation("auth");
  const [declined, setDeclined] = useState(false);
  const { data } = useGetCurrentUserQuery(undefined, { skip: !hasStoredToken || declined });
  const name = declined ? undefined : data?.currentUser.name;

  return (
    <div className="fullpage bg-primary-subtle">
      <div className="text-center px-3 mw-sm">
        <div className="mb-40px">
          <Logo />
        </div>

        <Image src="/images/capy-paused.svg" alt="" className="mb-20px" />

        <h1 className="h2">{t("zonaUnavailable.heading")}</h1>

        {typeof name === "string" && name.length > 0 ? (
          <>
            <p>{t("zonaUnavailable.continueAs", { name })}</p>

            <Button className="w-100 mb-3" onClick={onContinue}>
              {t("zonaUnavailable.continueButton")}
            </Button>
            <Button
              variant="outline-primary"
              className="w-100"
              onClick={() => {
                setDeclined(true);
              }}
            >
              {t("zonaUnavailable.notMe", { name })}
            </Button>
          </>
        ) : (
          <>
            <p>{t(isRetrying ? "zonaUnavailable.retrying" : "zonaUnavailable.retryLater")}</p>

            <Button className="w-100" onClick={onRetry}>
              {t("zonaUnavailable.retryButton")}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default ZonaUnavailable;
